import gql from 'graphql-tag';

import { EVENT_FRAGMENT } from '../../fragments/event.fragment';

export const MOVE_TO_TOMORROW_DATE_EVENT_ACTIVITIES = gql`
  mutation moveToTomorrowDateEventActivities($input: MoveToTomorrowEventActivitiesInput!) {
    dealActivity {
      result: moveToTomorrowEventActivities(input: $input) {
        error
        success
        list {
          __typename
          ...EventFields
        }
      }
    }
  }
  ${EVENT_FRAGMENT}
`;
